import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor() {}
  requestNotificationPermission(): void {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
        } else {
          console.log('Notification permission denied.');
        }
      });
    } else {
      console.log('Browser does not support notifications1.');
    }
  }

  showNotification(title: string, body: string): void {
    if ('Notification' in window && Notification.permission === 'granted') {
      // new Notification(title, { body });
      const notification = new Notification(title, { body, requireInteraction: true });

      notification.onclick = (event) => {
        event.preventDefault();
        notification.close();
      };
    }
  }
}
